/** @jsxImportSource react */
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useNotify } from '../common/NotificationProvider'

/** A read-only value with a copy button (keys, links, embed code). */
const CopyField = ({ label, value, multiline = false, helperText }) => {
  const notify = useNotify()
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      notify('Copied')
    } catch {
      notify('Select the text and copy it', 'warning')
    }
  }
  return (
    <TextField label={label} value={value} fullWidth multiline={multiline} minRows={multiline ? 2 : undefined} helperText={helperText}
      InputProps={{
        readOnly: true,
        sx: { fontFamily: 'monospace', fontSize: 13 },
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title="Copy"><IconButton onClick={copy} aria-label={`Copy ${label}`} edge="end"><ContentCopyIcon fontSize="small" /></IconButton></Tooltip>
          </InputAdornment>
        ),
      }} />
  )
}

export default CopyField
